import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';


let obx = observable({
  vouchers: [],
  filters: {},
  getVouchers: action(function() {
    SessionStore.startLoading('Loading…', 'Vouchers');

    let query = '?limit=500';

    if(Object.keys(obx.filters).length > 0) {
      for(var key in obx.filters) {
        if(obx.filters[key]) {
          query += `&${key}=${obx.filters[key]}`
        }
      }
    }

    api.get(`/installs/${SessionStore.userData.installSid}/vouchers${query}`)
      .then(response => {
        obx.vouchers = response.data.results;

        SessionStore.finishLoading('Vouchers');
      })
      .catch(error => {
        console.log(error.stack || error);
        SessionStore.throwError(error);
      });
  }),
  voucherData: {},
  resetVoucher: action(function(){
    obx.voucherData = {};
  }),
  getVoucher: action(function (sid) {
    SessionStore.startBackgroundLoading('GetVoucher');
    obx.resetVoucher();

    api.get(`/installs/${SessionStore.userData.installSid}/vouchers/${sid}`)
      .then(response => {
        obx.voucherData = response.data;
        SessionStore.finishBackgroundLoading('GetVoucher');
      })
      .catch(error => {
        console.log(error.stack || error);
        SessionStore.throwError(error);
      });
  }),
  deleteVoucher: action(function (sid) {
    SessionStore.startLoading('Loading…', 'DeleteVoucher');
    api.delete(`/installs/${SessionStore.userData.installSid}/vouchers/${sid}`)
      .then(response => {
        SessionStore.finishLoading('DeleteVoucher');
        obx.getVouchers();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  createVoucher: action(function (data, func) {
    SessionStore.startLoading('Loading…', 'CreateVoucher');
    if(data.nonTransferable) {
      data.assignedToUserSid = sessionStorage.userData.userSid;
    }
    api.post(`/installs/${SessionStore.userData.installSid}/vouchers`, data)
      .then(response => {
        for(let voucher of response.data.results){
          // reassigning obx.vouchers to response.data.results does not trigger the filterVouchers method
          // so we are modifying the existing array
          obx.vouchers.push(voucher);
        }
        // trigger the callback
        func();
        SessionStore.finishLoading('CreateVoucher');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  updateVoucher: action(function (sid, data, func) {
    SessionStore.startBackgroundLoading('UpdateVoucher');

    api.put(`/installs/${SessionStore.userData.installSid}/vouchers/${sid}`, data)
      .then(response => {
        // set the updated data to list element
        obx.getVouchers();
        func();
        SessionStore.finishBackgroundLoading('UpdateVoucher');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/VoucherStore.js